import { EventType, handleEvent } from "./base";

export const identify = (userId: string) => {
  try {
    window.mixpanel.identify(userId);
  } catch (e) {
    console.error(e);
  }
};

export const resetTrackingId = () => {
  try {
    window.mixpanel.reset();
  } catch (e) {
    console.error(e);
  }
};

export const fireSignInEvent = () => {
  handleEvent(EventType.Authentication, {
    action: "sign_in_click",
  });
};

export const fireSignOutEvent = () => {
  handleEvent(EventType.Authentication, {
    action: "sign_out_click",
  });
};

export const fireSignInAbandonEvent = () => {
  handleEvent(EventType.Authentication, {
    action: "sign_in_abandon",
  });
};

export const handleLoginPromptOpenEvent = (target: string) => {
  handleEvent(EventType.Authentication, {
    action: "open_login_prompt",
    target,
  });
};

export const handleLoginPromptCloseEvent = () => {
  handleEvent(EventType.Authentication, {
    action: "close_login_prompt",
  });
};
